import {
  GET_CURRENT_CONTRACT,
  GET_PACKAGE_PRICES,
  CREATE_SUBSCRIPTION_REQUEST,
  LAST_SUBSCRIPTION_REQUEST,
  CONTACT_ME_REQUEST,
  FETCH_PAYMENT_LINK,
  FETCH_PAYMENT_STATUS,
  UPDATE_NEWS_LETTERS,
  FETCH_COMPANY_TYPES,
  CREATE_CUSTOMER_AND_SETUP_INTENT,
  MAKE_PAYMENT,
  ATTACH_PAYMENT_METHOD,
  RESET_ERROR
} from 'constants/action-types';
import type {
  CompanyType,
  Country,
  CurrentContract,
  PackagePrices,
  State,
  SubscriptionRequest
} from 'types/join';

export type PlanState = {
  currentContract: CurrentContract | null;
  packagePrices: PackagePrices[] | null;
  subsscriptionRequest: SubscriptionRequest | null;
  showErrorPopup: { numOfTries: 0; show: boolean; errorMessage?: string | null };
  paymentLink: string | null;
  paymentStatus: string | null;
  opportunityId: string | null;
  sfContactId: string | null;
  contactMeSuccess: boolean;
  subscriptionId: string | null;
  paymentTask: string | null;
  subscriptionType: string | null;
  companyTypes: CompanyType[];
  payment: {
    clientSecret: string | null;
    customerId: string | null;
  };
};

const initialState: PlanState = {
  currentContract: null,
  packagePrices: null,
  subsscriptionRequest: null,
  showErrorPopup: { numOfTries: 0, show: false, errorMessage: null },
  paymentLink: null,
  paymentStatus: null,
  opportunityId: null,
  sfContactId: null,
  contactMeSuccess: false,
  subscriptionId: null,
  paymentTask: null,
  subscriptionType: null,
  companyTypes: [],
  payment: {
    clientSecret: null,
    customerId: null
  }
};

export const plan = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_CURRENT_CONTRACT.success: {
      return {
        ...state,
        currentContract: action.payload,
        paymentLink: action.payload.draftPaymentLink,
        opportunityId: action.payload.draftOportunityId,
        showErrorPopup: { numOfTries: 0, show: false }
      };
    }
    case GET_PACKAGE_PRICES.success: {
      return {
        ...state,
        packagePrices: action.payload,
        subscriptionType: action.payload.length > 0 ? action.payload[0].subscriptionType : null
      };
    }
    case CREATE_SUBSCRIPTION_REQUEST.success: {
      if (action.payload) {
        return {
          ...state,
          subscriptionId: action.payload.subscriptionId,
          sfContactId: action.payload.contactId,
          showErrorPopup: { numOfTries: 0, show: false }
        };
      } else {
        return {
          ...state,
          showErrorPopup: { numOfTries: state.showErrorPopup.numOfTries + 1, show: true }
        };
      }
    }
    case CREATE_SUBSCRIPTION_REQUEST.error: {
      const errorMessages = action.payload?.message;
      let errorMessage = null;
      if (errorMessages) {
        const errorMessagesParsed = JSON.parse(errorMessages);
        errorMessage = errorMessagesParsed?.errorMessage;
      }
      return {
        ...state,
        showErrorPopup: {
          numOfTries: state.showErrorPopup.numOfTries + 1,
          show: true,
          errorMessage
        }
      };
    }
    case LAST_SUBSCRIPTION_REQUEST.success: {
      return {
        ...state,
        paymentLink: action.payload.paymentRequestLink,
        opportunityId: action.payload.opportunityId
      };
    }
    case LAST_SUBSCRIPTION_REQUEST.error: {
      return {
        ...state
      };
    }
    case CONTACT_ME_REQUEST.success: {
      return {
        ...state,
        paymentTask: action.payload
      };
    }
    case FETCH_PAYMENT_LINK.success: {
      return {
        ...state,
        paymentLink: action.payload.paymentRequestLink
      };
    }
    case FETCH_PAYMENT_STATUS.success: {
      return {
        ...state,
        paymentStatus: action.payload
      };
    }
    case UPDATE_NEWS_LETTERS.success: {
      return {
        ...state,
        showErrorPopup: { numOfTries: 0, show: false }
      };
    }
    case UPDATE_NEWS_LETTERS.error: {
      return {
        ...state,
        showErrorPopup: { numOfTries: state.showErrorPopup.numOfTries + 1, show: true }
      };
    }
    case FETCH_COMPANY_TYPES.success: {
      return {
        ...state,
        companyTypes: action.payload
      };
    }
    case RESET_ERROR: {
      return {
        ...state,
        showErrorPopup: { numOfTries: 0, show: false, errorMessage: null }
      };
    }
    case CREATE_CUSTOMER_AND_SETUP_INTENT.success: {
      return {
        ...state,
        payment: {
          clientSecret: action.payload.clientSecret,
          customerId: action.payload.customerId
        }
      };
    }
    default: {
      return state;
    }
  }
};
